export const FILE_EXTENSION_BLACK_LIST = [
  // 실행파일
  '.class',
  '.com',
  '.dll',
  '.drv',
  '.grp',
  '.exe',
  '.chm',
  '.lib',
  '.pif',
  '.reg',
  '.scr',
  '.hlp',
  '.shs',
  '.msi',
  '.msp',
  '.msc',
  '.nsh',
  '.ocx',
  '.ovl',
  '.sys',
  '.vdl',
  '.vxd',
  // 스크립트
  '.js',
  '.jse',
  '.vb',
  '.vbe',
  '.vbs',
  '.pcd',
  '.wsc',
  '.wsf',
  '.wsh',
  '.hta',
  '.cmd',
  '.bat',
  '.acc',
  '.asp',
  '.ccs',
  '.htx',
  '.je',
  '.php',
  '.php3',
  '.sbs',
  '.sct',
  '.shb',
  '.shd',
  '.vba',
  '.ws',
  '.wst',
  '.jar',
  '.ps1',
  '.ps1xml',
  '.ps2',
  '.ps2xml',
  '.psc1',
  '.psc2',
  '.msh',
  '.msh1',
  '.msh2',
  '.mshxml',
  '.msh1xml',
  '.msh2xml',
  '.cpio',
  '.shar',
  '.sbx',
  '.tar',
  // 금지 압축/아카이브
  '.bz2',
  '.gz',
  '.lz',
  '.lz',
  '.lzma',
  '.lzo',
  '.sz',
  '.xz',
  '.z',
  '.s7z',
  '.ace',
  '.afa',
  '.apk',
  '.arj',
  '.b1',
  '.cab',
  '.cfs',
  '.dar',
  '.dgc',
  '.dmg',
  '.gca',
  '.lzh',
  '.lha',
  '.lzx',
  '.sit',
  '.sitx',
  '.tgz',
  '.zoo',
  '.par',
  '.par2',
  // 바로가기
  '.lnk',
  '.ink',
  '.scf',
  // 기타
  '.ade',
  '.adp',
  '.ldb',
  '.mad',
  '.mda',
  '.mdb',
  '.mdz',
  '.snp',
  '.bas',
  '.mde',
  '.mst',
  '.cpl',
  '.crt',
  '.ins',
  '.isp',
];

export const FILE_EXTENSION_WHITE_LIST = [
  // 미디어
  '.mp3',
  '.wma',
  '.wav',
  '.ogg',
  '.flac',
  '.mid',
  '.ac3',
  '.aac',
  '.ra',
  '.avi',
  '.mpg',
  '.mpeg',
  '.asf',
  '.asx',
  '.wmv',
  '.mov',
  '.mp4',
  '.mkv',
  '.rm',
  '.ram',
  // 그래픽
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.tiff',
  '.bmp',
  '.svg',
  '.psd',
  '.ai',
  // 문서
  '.hwp',
  '.hwpmi',
  '.owpmi',
  '.hwpx',
  '.hwt',
  '.cell',
  '.show',
  '.xls',
  '.xlsx',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.docm',
  '.key',
  '.numbers',
  '.html',
  '.htm',
  '.xml',
  '.csv',
  '.txt',
  '.rtf',
  '.pdf',
  '.md',
  // 허용 압축/아카이브
  '.zip',
  '.alz',
  '.egg',
  '.rar',
  '.7z',
];
